export default __webpack_public_path__ + "static/media/ManualSchedule.8fc872dc.svg";